<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.GradingResults"
  class="section-header-general section-header-review-score"
  [class.section-header-review-score-with-logo]="!colVm?.columnConfig?.columnName">
  @if (colVm?.columnConfig?.columnName; as columnName) {
    {{ columnName }}
  } @else if (colVm?.columnConfig?.dataValue === Types.GradingProvider.DankReviews) {
    <img
      src="assets/images/dank-reviews/dank-reviews.png"
      alt="Dank Reviews Logo"
      class="section-header-grading-provider-logo" />
  } @else if (colVm?.columnConfig?.dataValue === Types.GradingProvider.Sensemillier) {
    <img
      src="assets/images/sensemillier/sensemillier.png"
      alt="Sensemillier Logo"
      class="section-header-grading-provider-logo" />
  } @else {
    Grading
  }
</div>
